import { t } from "./i18n";
import { useTranslation } from 'react-i18next';
import { Alert, CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AuthSessionGate from './auth/AuthSessionGate';
import AuthShell from './components/AuthShell';
import AppRoutes from './routes';
import { isConfigured } from './configs/aws';
import { portalBrand } from './configs/brand';
import applyAccentOverrides from './themes/accentOverrides';
const queryClient = new QueryClient();
const theme = createTheme({
  palette: {
    primary: {
      main: portalBrand.main,
      dark: portalBrand.dark
    },
    secondary: {
      main: portalBrand.main,
      dark: portalBrand.dark
    },
    accent: {
      main: portalBrand.accent
    },
    background: {
      default: '#f4f6f8'
    }
  },
  typography: {
    fontFamily: 'Arial, sans-serif'
  },
  shape: {
    borderRadius: 12
  },
  components: applyAccentOverrides({}, portalBrand.accent)
});
export default function App() {
  useTranslation();
  return <ThemeProvider theme={theme}>
            <CssBaseline />
            {isConfigured ? <QueryClientProvider client={queryClient}>
                    <BrowserRouter>
                        <AuthSessionGate><AppRoutes /></AuthSessionGate>
                    </BrowserRouter>
                </QueryClientProvider> : <AuthShell title={t("Configuração necessária")}>
                    <Alert severity="warning">{t("Configure a API e o Cognito no ficheiro .env e reinicie a aplicação.")}</Alert>
                </AuthShell>}
        </ThemeProvider>;
}
